export const formError = Object.freeze({
  general: "We're unable to process your request. Please try again.",
  tooLong: 'The entered text is too long.',
  critical: 'Something went wrong, please try again later.',
  invalid: 'Please enter a valid value.',
});
